import { render, staticRenderFns } from "./user-descript.vue?vue&type=template&id=7e637049&scoped=true&"
import script from "./user-descript.vue?vue&type=script&lang=js&"
export * from "./user-descript.vue?vue&type=script&lang=js&"
import style0 from "./user-descript.vue?vue&type=style&index=0&id=7e637049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e637049",
  null
  
)

export default component.exports